export default __webpack_public_path__ + "static/media/redux_logo.010fcccb.png";